import React, { Component } from "react";
import "./App.css";

//common
import Banner from "../component/common/banner/Banner";
import NavBar from "../component/common/nav/NavBar";
import Footer from "../component/common/footer/Footer";

import Profile from "../component/profile/Profile";

class App extends Component {
	render() {
		return (
			<React.Fragment>
				<NavBar/>
				<Banner />
				<Profile/>
				<Footer/>
			</React.Fragment>
		);
	}
}

export default App;
